import React from 'react';
import styled from 'styled-components';

import { useStaticQuery, graphql } from 'gatsby';

import GlobalStyles from './global-styles';

import Header from './layout/header';

const MainGrid = styled.div`
  display: grid;
  grid-template-areas:
    "header"
    "content";
  grid-template-rows: 7.2rem 1fr;
  grid-template-columns: 1fr;

  @media (min-width: 540px) {
    grid-template-rows: 5.25rem 1fr;
  }

  @media only screen and (min-width: 900px) {
    grid-template-areas: "header content";
    grid-template-columns: var(--sidebar-width) 1fr;
    grid-template-rows: 1fr;
    align-items: flex-start;
  }
`;

const MainContent = styled.main`
  grid-area: content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--spacer);
  align-self: stretch;
  justify-content: center;
`;

function generateMediaQueries(data) {
  return data.split(',\n')
    .map((v) => v.split(' ').map((t) => t.trim()))
    .map(([url, breakpoint]) => {
      const minWidth = parseInt(breakpoint.substr(0, breakpoint.length - 1), 10) - 200;

      return `@media (min-width: ${minWidth}px) and (orientation: landscape) {
        background-image: url("${url}");
      }`;
    });
}

function getBackgrounds(data) {
  const light = data.allFile.edges.find(({ node }) => node.name === 'light');
  const dark = data.allFile.edges.find(({ node }) => node.name === 'dark');

  return {
    dark: {
      src: dark.node.childImageSharp.fixed.srcWebp,
      mediaQueries: generateMediaQueries(dark.node.childImageSharp.fluid.srcSetWebp),
    },
    light: {
      src: light.node.childImageSharp.fixed.srcWebp,
      mediaQueries: generateMediaQueries(light.node.childImageSharp.fluid.srcSetWebp),
    },
  };
}

export default function Layout({ menu = {}, privacy = true, children }) {
  const data = useStaticQuery(graphql`
  {
    allFile(filter: {extension: {eq: "png"}, relativeDirectory: {glob: "*background*"}}) {
      edges {
        node {
          publicURL,
          name
          childImageSharp {
            fluid(srcSetBreakpoints: [650, 900, 1200, 1600, 2560], webpQuality: 85) {
              srcWebp
              srcSetWebp
            },
            fixed(width: 400, height: 720, webpQuality: 85, cropFocus: CENTER) {
              srcWebp
            }
          }
        }
      }
    }
  }
  `);

  const backgrounds = getBackgrounds(data);

  return (
    <MainGrid>
      <GlobalStyles backgrounds={backgrounds} />

      {/* <SidebarWrapper> */}
      <Header nav={menu} privacy={privacy} />
      {/* </SidebarWrapper> */}

      <MainContent>{children}</MainContent>
    </MainGrid>
  );
}
